export function updateCurrencyKeyInMap(inputMap, currencyCode, mapBuilderFunction) {
  return Object.fromEntries(Object.entries(inputMap).map(([key, value]) => [key, mapBuilderFunction(value, currencyCode)]));
}